module.exports = __webpack_public_path__ + "static/img/son4_active.cc5a180f.png";